/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const HealthMonitoring = loadable(() => import('./Monitoring'), {
  fallback: <LoadingIndicator />,
});

export const LocationMonitoring = loadable(() => import('./LocationWrapper'), {
  fallback: <LoadingIndicator />,
});
